module.exports = __webpack_public_path__ + "img/donation-thank-you.80a631dd.png";